import React, { Component } from 'react';
import { Form, Input, DatePicker } from 'antd';
import { FormLayout, CarPosition, SelectQuery } from '@/components';
import { dispatch } from '@@/store';
import { CHECK_name, CHECK_phone } from '@/shared/reqexp';
import moment from 'moment';
// import {dispatch} from '@@/store';
class FormSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.search = this.search.bind(this);
    }
    search(data) {
        if (data.locationCode) {
            data.localProvinceCode = data.locationCode[0];
            data.locationCode = data.locationCode[1];
        }
        if (data.time) {
            data.startTime = data.time[0];
            data.endTime = data.time[1];
            delete data.time;
        }
        dispatch.approve.SET_STATE({
            searchData: data,
        });
        dispatch.approve.updateTable({ page: 1 });
    }
    dealDate(currentDate) {
        const now = moment();
        return currentDate > now;
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        return (<FormLayout form={this.props.form} onSearch={this.search}>
        <Form.Item label={'车辆所在地'}>
          {getFieldDecorator('locationCode', {})(<CarPosition />)}
        </Form.Item>
        <Form.Item label={'VIN码/车牌号'}>
          {getFieldDecorator('code', {
            rules: [{
                    pattern: CHECK_name(20),
                    message: '请输入VIN码/车牌号',
                }],
        })(<Input placeholder={'请输入VIN码/车牌号'}/>)}
        </Form.Item>
        <Form.Item label={'经销商名称'}>
          {getFieldDecorator('sellerCode')(<SelectQuery labelInValue={false}/>)}
        </Form.Item>
        <Form.Item label={'经销商联系电话'}>
          {getFieldDecorator('sellerPhone', {
            rules: [{
                    pattern: CHECK_phone,
                    message: '请输入正确的手机号',
                }],
        })(<Input placeholder={'请输入经销商联系电话'}/>)}
        </Form.Item>
        <Form.Item className={'width-100'} label={'申请时间'} wrapperCol={{ span: 16 }}>
          {getFieldDecorator('time')(<DatePicker.RangePicker className={'width-100'} disabledDate={this.dealDate} getCalendarContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }}/>)}
        </Form.Item>
      </FormLayout>);
    }
}
const FormSearchForm = Form.create({})(FormSearch);
export default FormSearchForm;
